import createSvgIcon from '../Utils/CreateSvgIcon';

export const BodyColorBrown = createSvgIcon(
  <circle cx="10" cy="10" fill="#7B431B" r="10" transform="matrix(1 0 0 -1 2 22)" />,
  'BodyColorBrown',
);
